import { Form } from '@roo/roo';
import React from 'react';
import { UploadField } from '../../_components/UploadField';
const Field=Form.Field

// 知识产权
export const Credential = function () {
  return (
    <>
      <div className='form-patch bc'>
        <div className={'field-upload'}>
          <Field label='证书上传' layout='vertical' name={`otherCredentials`} withLabel={false}>
            {({ value, handleChange }) => {
              return (
                <UploadField type={'doc'} maxFiles={5} value={value} handleChange={handleChange} limitSizeTip="1G"/>
              );
            }}
          </Field>
        </div>
      </div>
    </>
  );
};
